export default __webpack_public_path__ + "static/media/decrypted-logo.3a002786.svg";